module.exports = __webpack_public_path__ + "static/media/16UNODC14.ad3ca251.jpg";